import type { DeviceLocation } from "@/entities/DeviceLocation";

/** Last 5 chars of a uuid, for compact display. */
export const shortUuid = (uuid: string) =>
  uuid.length <= 5 ? uuid : uuid.slice(-5);

/** Label for a device: `name (short uuid)`, or just the short UUID if it has no name. */
export const getDeviceLabel = (device: DeviceLocation) => {
  const name = device.device_name?.trim();
  // The backend fills device_name with the uuid when the device has no name
  return name && name !== device.uuid
    ? `${name} (${shortUuid(device.uuid)})`
    : shortUuid(device.uuid);
};
